// @flow

import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import _ from 'lodash/fp';
import VariantImage from '../VariantImage/VariantImage';
import './ProductVariantImages.css';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

export type Props = {
  onDrop: Function,
  onActiveImage: Function,
  onDefaultImage: Function,
  onRemoveImage: Function,
  images: any[],
  imagesInProgress: any[],
  activeImage?: any,
  activeVariant?: any,
};

class ProductVariantImages extends Component<Props> {
  props: Props;
  _dropzone: any;

  openDropzone() {
    if (this._dropzone) {
      this._dropzone.open();
    }
  }

  render() {
    const {
      images,
      imagesInProgress,
      activeVariant,
      activeImage,
      onDrop,
      onActiveImage,
      onDefaultImage,
      onRemoveImage,
    } = this.props;
    const {id: variantId = 0} = activeVariant || {};

    const defaultImage =
      _.find('isDefault', images);

    const currentImage =
      activeImage ||
      defaultImage ||
      _.head(images);

    let url, name;
    if (currentImage) {
      url = `${fileUrl}/preview/${currentImage.id}/340`;
      name = currentImage.name;
    }

    return (
      <div className="ProductVariantImages">
        <div className="row">
          <div className="small-6 column">
            <label>
              Standardbild
            </label>
            <div className="ProductVariantImages-preview">
              {currentImage && (
                <img
                  className="ProductVariantImages-preview-image"
                  src={url}
                  alt={name} />
              )}
              {currentImage && (
                <button
                  onClick={() => onDefaultImage(currentImage)}
                  disabled={defaultImage && currentImage.id === defaultImage.id}
                  type="button"
                  className="button ProductVariantImages-default-button">
                Sätt standardbild
                </button>
              )}
            </div>
          </div>
          <div className="small-6 column">
            <label>
              Variantbilder
            </label>
            <Dropzone
              onDrop={files => onDrop(variantId, files)}
              disableClick={true}
              multiple={false}
              accept="image/*"
              ref={ref => this._dropzone = ref}
              className="ProductVariantImages-Dropzone">
              {(images.length || imagesInProgress.length)
                ? (
                  <ul className="ProductVariantImages-menu">
                    {!!images.length &&
                      _.map(image => (
                        <VariantImage
                          classes={{active: currentImage && image.id === currentImage.id}}
                          key={image.id}
                          name={image.name}
                          url={`${fileUrl}/preview/${image.id}/20`}
                          onActiveImage={() => onActiveImage(image)}
                          onRemoveImage={() => onRemoveImage(variantId, image.id)} />
                      ), images)
                    }
                    {!!imagesInProgress.length &&
                      _.map(image => (
                        <VariantImage
                          classes={{'has-error': !!image.error}}
                          key={image.tempId}
                          name={image.file.name}
                          url={image.file.preview}
                          onRemoveImage={() => onRemoveImage(variantId, image.tempId, true)} />
                      ), imagesInProgress)
                    }
                  </ul>
                )
                : (<span>Släpp en bild här för att ladda upp</span>)
              }
            </Dropzone>
            <button
              onClick={() => this.openDropzone()}
              type="button"
              className="button ProductVariantImages-new-button">
              Ladda upp ny bild
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductVariantImages;



// WEBPACK FOOTER //
// ./src/components/ProductVariantImages/ProductVariantImages.js